<template>
  <div class="card">
    <div class="form-title">
      les repas que je cuisine et le temps maximum que j’ai pour cuisiner (préparation + cuisson)
    </div>

    <div>
      <table>
        <thead>
          <tr>
            <th />
            <th>Lundi</th>
            <th>Mardi</th>
            <th>Mercredi</th>
            <th>Jeudi</th>
            <th>Vendredi</th>
            <th>Samedi</th>
            <th>Dimanche</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Midi</td>
            <td>{{ displayCell("monday", "lunch") }}</td>
            <td>{{ displayCell("tuesday", "lunch") }}</td>
            <td>{{ displayCell("wednesday", "lunch") }}</td>
            <td>{{ displayCell("thursday", "lunch") }}</td>
            <td>{{ displayCell("friday", "lunch") }}</td>
            <td>{{ displayCell("saturday", "lunch") }}</td>
            <td>{{ displayCell("sunday", "lunch") }}</td>
          </tr>

          <tr>
            <td>Soir</td>
            <td>{{ displayCell("monday", "dinner") }}</td>
            <td>{{ displayCell("tuesday", "dinner") }}</td>
            <td>{{ displayCell("wednesday", "dinner") }}</td>
            <td>{{ displayCell("thursday", "dinner") }}</td>
            <td>{{ displayCell("friday", "dinner") }}</td>
            <td>{{ displayCell("saturday", "dinner") }}</td>
            <td>{{ displayCell("sunday", "dinner") }}</td>
          </tr>
        </tbody>
      </table>

      <div class="hint-text">
        Chaque repas à base de restes doit être précédé d’un repas cuisiné
        <br />
        L’analyse nutritionnelle est basée sur les repas cuisinés selon les recettes de Mes Meilleurs Menus.
      </div>

      <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
        <button class="button" @click="edit = true" style="margin-right: 10px;">
          <font-awesome-icon :icon="['fas', 'edit']" />
          Modifier
        </button>
      </div>
    </div>

    <EditPreparationTimeModal v-if="edit" :preferences="preferences" @close="edit = false" />
  </div>
</template>

<script>
import EditPreparationTimeModal from "@/components/EditPreparationTimeModal.vue";
import { userState } from "@/utils/store";

export default {
  name: "PreparationTime",
  components: {
    EditPreparationTimeModal,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    preferences() {
      return userState.me.consumer_account;
    },
  },
  methods: {
    mealModeLabel(mode) {
      const map = {
        outside: "À l’extérieur",
        leftovers: "Restes du repas précédent",
        max_30: "30 min",
        max_40: "40 min",
        max_50: "50 min",
        over_60: "+1 heure",
      };

      return map[mode] || "—";
    },

    humanizeOldTime(time) {
      if (time == null) return "Peu importe";
      return time + " min";
    },

    displayCell(day, meal) {
      // new field
      const modeKey = `meal_mode_${day}_${meal}`;
      const mode = this.preferences?.[modeKey];

      if (mode) {
        return this.mealModeLabel(mode);
      }

      // fallback old field
      const oldKey = `max_meal_preparation_time_${day}_${meal}`;
      const oldTime = this.preferences?.[oldKey];
      return this.humanizeOldTime(oldTime);
    },
  },
};
</script>

<style scoped>
.card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto;
  grid-auto-flow: row;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  font-size: 14px;
}

th,
td {
  text-align: center;
  padding: 12px 8px;
  border: 1px solid #e0e0e0;
}

th {
  background-color: #f5f5f5;
  color: #333;
  font-weight: 600;
}

tbody td:first-child {
  font-weight: 600;
  background-color: #f0f0f0;
  color: #2f3e46;
}

.hint-text {
  margin-top: 12px;
  font-size: 13px;
  color: #555;
  line-height: 1.4;
}
</style>
